import React from 'react';

/// functional component - have first letter capitalized
const Intro = props => (
    <p>
   {props.message}
  </p>
  );

  export default Intro;